import { SearchMessageChannels } from "../message";
export const QueryTypes = SearchMessageChannels;
export var EntityType;
(function (EntityType) {
    EntityType["Event"] = "Event";
    EntityType["League"] = "League";
})(EntityType || (EntityType = {}));
//# sourceMappingURL=search.js.map